import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useScreen from 'hooks/useScreen';
import useProductCardContext from 'data-hooks/useProductCardContext';
import BarbieLogo from 'assets/images/made-for-barbie-logo.png';
import BipocLogo from 'assets/images/bipoc-badge.png';
import IconGreenguardGold from 'components/icons/PDPSellingAttributes/IconGreenguardGold';
import isT1Image from 'commons/isT1Image';
import { IMAGE_FLIP_SKUS } from 'commons/constants';
import ProductCardConfigImage from './ProductCardConfigImage';
import ProductCardStudioImage from './ProductCardStudioImage';
import ProductCardPhotoSlider from './ProductCardPhotoSlider';
const ProductCardPhotoSquare = t0 => {
  const $ = _c(48);
  const {
    disableImageLazyLoading,
    prioritizeImage,
    enableMobileCarousel
  } = t0;
  const {
    image,
    secondaryImage,
    secondaryImageCropData,
    variantsToShow,
    campaign,
    sku
  } = useProductCardContext();
  const {
    isMobile
  } = useScreen();
  const isDesktop = !isMobile;
  let t1;
  if ($[0] !== sku) {
    t1 = sku?.split("-").some(_temp) ?? false;
    $[0] = sku;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isFlipped = t1;
  const showSecondaryImageAsPrimary = !variantsToShow?.length && !image && !!secondaryImage;
  let t2;
  if ($[2] !== campaign || $[3] !== disableImageLazyLoading || $[4] !== image || $[5] !== isFlipped || $[6] !== prioritizeImage) {
    t2 = <ProductCardConfigImage disableImageLazyLoading={disableImageLazyLoading} prioritizeImage={prioritizeImage} image={image} campaign={campaign} isFlipped={isFlipped} />;
    $[2] = campaign;
    $[3] = disableImageLazyLoading;
    $[4] = image;
    $[5] = isFlipped;
    $[6] = prioritizeImage;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const primaryImageElement = t2;
  const isSecondaryConfigImage = isT1Image(secondaryImage) && !secondaryImageCropData;
  let t3;
  bb0: {
    if (!secondaryImage) {
      t3 = null;
      break bb0;
    }
    if (isSecondaryConfigImage) {
      let t4;
      if ($[8] !== isFlipped || $[9] !== secondaryImage) {
        t4 = <ProductCardConfigImage image={secondaryImage} isFlipped={isFlipped} />;
        $[8] = isFlipped;
        $[9] = secondaryImage;
        $[10] = t4;
      } else {
        t4 = $[10];
      }
      t3 = t4;
      break bb0;
    }
    let t4;
    if ($[11] !== isMobile || $[12] !== secondaryImage || $[13] !== secondaryImageCropData) {
      t4 = <ProductCardStudioImage cropData={secondaryImageCropData} image={secondaryImage} isMobile={isMobile} />;
      $[11] = isMobile;
      $[12] = secondaryImage;
      $[13] = secondaryImageCropData;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = t4;
  }
  const secondaryImageElement = t3;
  let t4;
  bb1: {
    if (!showSecondaryImageAsPrimary || !secondaryImage) {
      t4 = null;
      break bb1;
    }
    if (isSecondaryConfigImage) {
      let t5;
      if ($[15] !== disableImageLazyLoading || $[16] !== isFlipped || $[17] !== prioritizeImage || $[18] !== secondaryImage) {
        t5 = <ProductCardConfigImage disableImageLazyLoading={disableImageLazyLoading} prioritizeImage={prioritizeImage} image={secondaryImage} isFlipped={isFlipped} />;
        $[15] = disableImageLazyLoading;
        $[16] = isFlipped;
        $[17] = prioritizeImage;
        $[18] = secondaryImage;
        $[19] = t5;
      } else {
        t5 = $[19];
      }
      t4 = t5;
      break bb1;
    }
    let t5;
    if ($[20] !== disableImageLazyLoading || $[21] !== isMobile || $[22] !== secondaryImage || $[23] !== secondaryImageCropData) {
      t5 = <ProductCardStudioImage cropData={secondaryImageCropData} disableImageLazyLoading={disableImageLazyLoading} image={secondaryImage} isMobile={isMobile} />;
      $[20] = disableImageLazyLoading;
      $[21] = isMobile;
      $[22] = secondaryImage;
      $[23] = secondaryImageCropData;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    t4 = t5;
  }
  const eagerSecondaryImageElement = t4;
  const firstImageToShow = showSecondaryImageAsPrimary ? eagerSecondaryImageElement : primaryImageElement;
  const secondImageToShow = showSecondaryImageAsPrimary ? null : secondaryImageElement;
  const showCarouselOnMobile = enableMobileCarousel && !!secondImageToShow;
  const t5 = (isDesktop || !showCarouselOnMobile) && firstImageToShow;
  let t6;
  if ($[25] !== campaign) {
    t6 = campaign === "barbie" && <img src={BarbieLogo} alt="barbie-logo" className="w-12 h-12 absolute bottom-2 right-4" />;
    $[25] = campaign;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== campaign) {
    t7 = campaign === "bipoc" && <img src={BipocLogo} alt="bipoc-owned-logo" className="w-12 h-12 absolute bottom-2 right-4" />;
    $[27] = campaign;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== campaign) {
    t8 = campaign === "greenguard" && <IconGreenguardGold className="w-12 h-12 absolute bottom-2 right-4 z-10" />;
    $[29] = campaign;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== t6 || $[32] !== t7 || $[33] !== t8) {
    t9 = <div className="w-full flex flex-row justify-end absolute bottom-2">{t6}{t7}{t8}</div>;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== isDesktop || $[36] !== secondImageToShow) {
    t10 = isDesktop && !!secondImageToShow && <div className="absolute w-full h-full top-0 left-0 transition-opacity duration-700 ease-out opacity-0 group-hover/product-card:opacity-100 bg-gray-light8 flex flex-col items-center justify-center">{secondImageToShow}</div>;
    $[35] = isDesktop;
    $[36] = secondImageToShow;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== firstImageToShow || $[39] !== isMobile || $[40] !== secondImageToShow || $[41] !== showCarouselOnMobile) {
    t11 = isMobile && showCarouselOnMobile && <ProductCardPhotoSlider image1={firstImageToShow} image2={secondImageToShow} />;
    $[38] = firstImageToShow;
    $[39] = isMobile;
    $[40] = secondImageToShow;
    $[41] = showCarouselOnMobile;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  let t12;
  if ($[43] !== t10 || $[44] !== t11 || $[45] !== t5 || $[46] !== t9) {
    t12 = <div className="aspect-square relative bg-gray-light8 flex flex-col [transition:background-color_0.3s_ease-in-out] items-center justify-center overflow-hidden min-h-0">{t5}{t9}{t10}{t11}</div>;
    $[43] = t10;
    $[44] = t11;
    $[45] = t5;
    $[46] = t9;
    $[47] = t12;
  } else {
    t12 = $[47];
  }
  return t12;
};
ProductCardPhotoSquare.propTypes = {
  disableImageLazyLoading: PropTypes.bool,
  enableMobileCarousel: PropTypes.bool
};
export default ProductCardPhotoSquare;
function _temp(optionSku) {
  return IMAGE_FLIP_SKUS.includes(optionSku);
}